import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_@babel+core@7.14.3_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@vinted/web-ui';
import { NotificationPosition } from 'types/components';
import { VINTED_LOGO_IMAGE_PATH } from 'constants/images';
import { InboxNotificationType, PromoBoxType, PROMO_BOX_INDEX_IN_FEED_ROW, PROMO_BOX_PAGE_LENGTH, Translation, FullScreenInAppStyle, IN_APP_MAX_BUTTONS_COUNT } from 'constants/index';
import { InAppModalMessageType } from 'types/models/in-app-message';
import { logContentParseError } from 'libs/common/braze/utils/error-loggers';
export const transformInAppMessageTrackingData = dto => {
  let result;

  try {
    result = JSON.parse(dto.extras.tracking);
  } catch (_unused) {
    logContentParseError(dto.message, 'in-app-message', dto.extras.tracking);
    result = {};
  }

  return {
    campaignName: result.campaign_name,
    campaignMessageName: result.campaign_message_name,
    canvasName: result.canvas_name,
    canvasVariantName: result.canvas_variant_name
  };
};
export const transformBrazeInboxCardNotificationDto = dto => ({
  id: dto.id,
  body: dto.description,
  link: dto.url,
  photoUrl: dto.extras.logoURL || VINTED_LOGO_IMAGE_PATH,
  photoStyle: Image.Styling.Circle,
  time: dto.updated.getTime(),
  type: InboxNotificationType.Braze,
  isViewed: dto.viewed,
  isControl: dto.extras.variant === 'control',
  note: null // TODO: check if we need to transform dto.description into note

});
export const transformBrazeInboxMessageCardDto = dto => ({
  id: dto.id,
  messages: [],
  // braze message will be handled separately from context API to simplify parsing
  transactionId: undefined,
  isTranslated: false,
  oppositeUser: null,
  buyerId: undefined,
  isPaymentActionAvailable: false,
  translationType: Translation.None,
  isReadByOppositeUser: dto.viewed,
  itemId: undefined,
  isReplyAllowed: true,
  isSuspicious: false,
  isBundleAvailable: false,
  transaction: null,
  suggestedMessages: undefined,
  item: null,
  education: null,
  moderatedItems: null,
  isControl: dto.extras.variant === 'control',
  userHasSupportRole: false
});
export const transformBrazePromoBoxCardDto = dto => {
  var _dto$extras, _dto$extras2;

  const position = !dto.pinned && (_dto$extras = dto.extras) !== null && _dto$extras !== void 0 && _dto$extras.page && Number(dto.extras.page) ? (Number(dto.extras.page) - 1) * PROMO_BOX_PAGE_LENGTH + PROMO_BOX_INDEX_IN_FEED_ROW : undefined;
  return {
    id: dto.id,
    url: dto.url,
    backgroundColor: undefined,
    imageUrl: dto.imageUrl,
    impressionUrl: null,
    isControl: ((_dto$extras2 = dto.extras) === null || _dto$extras2 === void 0 ? void 0 : _dto$extras2.variant) === 'control',
    type: dto.pinned ? PromoBoxType.BrazeSticky : PromoBoxType.Braze,
    position
  };
};

const resolveInAppDuration = inAppMessage => inAppMessage.dismissType === 'AUTO_DISMISS' ? inAppMessage.duration : undefined;

const resolveInAppButtonUrl = button => (button === null || button === void 0 ? void 0 : button.clickAction) === 'URI' ? button.uri : undefined;

const sortButtons = buttons => {
  const hasTwoButtons = buttons.length === IN_APP_MAX_BUTTONS_COUNT;

  if (hasTwoButtons) {
    return {
      primaryButton: buttons[0],
      secondaryButton: buttons[1]
    };
  }

  const button = buttons[0];
  const hasUrl = button.clickAction === 'URI';
  return {
    primaryButton: hasUrl ? button : undefined,
    secondaryButton: hasUrl ? undefined : button
  };
};

export const transformBrazeSlideUpInAppMessageDto = dto => {
  return _objectSpread({
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    url: dto.uri,
    position: dto.slideFrom === 'TOP' ? NotificationPosition.Top : NotificationPosition.Bottom,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};
export const transformBrazeModalInAppMessageDto = dto => {
  const {
    primaryButton,
    secondaryButton
  } = sortButtons(dto.buttons);
  return _objectSpread({
    header: dto.header,
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    primaryButtonText: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text,
    secondaryButtonText: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text,
    primaryButtonUrl: resolveInAppButtonUrl(primaryButton),
    secondaryButtonUrl: resolveInAppButtonUrl(secondaryButton),
    videoURL: undefined,
    type: InAppModalMessageType.Splash,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};
export const transformBrazeFullScreenInAppMessageDto = dto => {
  const type = dto.extras.inAppStyle === FullScreenInAppStyle.Cover ? InAppModalMessageType.Cover : InAppModalMessageType.FullScreenSplash;
  const videoURL = type === InAppModalMessageType.FullScreenSplash && dto.extras.videoURL ? dto.extras.videoURL : undefined;
  const {
    primaryButton,
    secondaryButton
  } = sortButtons(dto.buttons);
  return _objectSpread({
    header: dto.header,
    message: dto.message,
    imageUrl: dto.imageUrl,
    duration: resolveInAppDuration(dto),
    primaryButtonText: primaryButton === null || primaryButton === void 0 ? void 0 : primaryButton.text,
    secondaryButtonText: secondaryButton === null || secondaryButton === void 0 ? void 0 : secondaryButton.text,
    primaryButtonUrl: resolveInAppButtonUrl(primaryButton),
    secondaryButtonUrl: resolveInAppButtonUrl(secondaryButton),
    videoURL,
    type,
    shouldOpenLinkInNewTab: dto.openTarget === 'BLANK',
    original: dto
  }, transformInAppMessageTrackingData(dto));
};